import { useEffect, useRef } from "react";
import type { PatchPilotConfig } from "./core/config";
import { PatchPilot } from "./index";

export type { PatchPilotConfig };
export type { PatchPilotOffset } from "./core/config";

export function PatchPilotProvider(props: PatchPilotConfig): null {
  const prevConfigRef = useRef<string>("");
  const initializedRef = useRef(false);

  // Full init on core config changes
  useEffect(() => {
    const serialized = JSON.stringify(props);
    if (serialized === prevConfigRef.current) return;
    prevConfigRef.current = serialized;

    PatchPilot.init(props);
    initializedRef.current = true;

    return () => {
      PatchPilot.destroy();
      initializedRef.current = false;
    };
  }, [props.apiKey, props.apiUrl, props.theme, props.locale, props.user]);

  // Lightweight position/offset update without re-init
  useEffect(() => {
    if (!initializedRef.current) return;
    PatchPilot.setPosition(
      props.position ?? "bottom-right",
      props.offset,
    );
  }, [props.position, props.offset]);

  return null;
}
